module.exports = __webpack_public_path__ + "static/media/notification_simple-01.27fbe8a5.wav";